// extracted by mini-css-extract-plugin
export var dark = "content-column-module--dark--d1408";
export var heading = "content-column-module--heading--7c3e4";
export var icon = "content-column-module--icon--26e61";
export var root = "content-column-module--root--2016f";